import React, { Component } from 'react';
import { Flex, Heading, Text, Link } from 'core/components';
import { MarkdownWrap } from 'app/components/markdown/Markdown';
import ToolResultCard from '../components/ToolResultCard';

class KbToolResult extends Component {
  render() {
    const { tool, onCloseToolResult } = this.props;
    const { raw_result } = tool;
    const { result, reference_articles = [] } = raw_result || {};

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        className="tool-result-kb"
        title={tool.title || 'Knowledge Base Result'}
        maxHeight={600}
        overflow="auto"
      >
        <Flex p={2} flexDirection="column" gap={3}>
          {result && (
            <Flex flexDirection="column" gap={2}>
              {/* eslint-disable-next-line react/no-danger */}
              <MarkdownWrap dangerouslySetInnerHTML={{ __html: result }} />
            </Flex>
          )}

          {reference_articles.length > 0 && (
            <Flex flexDirection="column" gap={2}>
              <Heading level={4} m={0} fontSize={16} fontWeight={700} mb={1}>
                Reference Articles
              </Heading>
              {reference_articles.map((article) => (
                <Flex flexDirection="column" key={article.id} py={1} borderBottom="thin">
                  <Link to={`https://kentik-documentation.us.document360.io/docs/${article.article_slug}?`} blank>
                    <strong>{article.article_title}</strong>
                    {article.category_title && <span> - {article.category_title}</span>}
                  </Link>
                  <Text muted small>
                    Citation: [{article.citation_id}]
                  </Text>
                </Flex>
              ))}
            </Flex>
          )}
        </Flex>
      </ToolResultCard>
    );
  }
}

export default KbToolResult;
